import React from "react";
import classNames from "classnames";

import { LinkButtonProps } from "./LinkButton.types";
import "./LinkButton.scss";

const LinkButton = React.forwardRef<HTMLAnchorElement, LinkButtonProps>(
  (
    {
      variant = "solid",
      theme = "primary",
      size = "medium",
      disabled = false,
      uppercase = false,
      children,
      className,
      ...props
    },
    ref
  ) => {
    const classes = classNames(
      "elemental-LinkButton",
      `btn-${variant}-${theme}`,
      `btn-${size}`,
      {
        "is-disabled": disabled,
        "is-uppercase": uppercase,
      },
      className
    );

    return (
      <a
        {...props}
        data-testid="link-button-component"
        className={classes}
        ref={ref}
      >
        {children}
      </a>
    );
  }
);

export default LinkButton;
